import React, { useContext} from 'react';
import styles from "../css/Navbar.module.css";
import logoImg from "../image/logo.png";
import {Link, NavLink} from "react-router-dom";
import UserContext from '../context/users/UserContext';
import barSvg from "../image/bars-solid.svg";
import timesSvg from "../image/times-solid.svg";
import LoginComp from './LoginComp';
import LogoutComp from './LogoutComp';
import uiContext from '../context/ui/uiContext';


function Navbar(props) {
    const context=useContext(UserContext);
    const widthContext=useContext(uiContext);
    const handleBurgerClick=()=>{
        if(widthContext.sideBar){
            widthContext.setSideBar(0);
        }
        else{
            widthContext.setSideBar(1);
        }
    }
    
    const handleNavClick=()=>{
        widthContext.setSideBar(0);
    }

    return (
        <>
        <div className={styles.mainHeader}>
        <div className={styles.logo}><Link to="/" onClick={handleNavClick}><img src={logoImg} alt="logo"/></Link></div>
        <div className={styles.searchbox}>
        </div>


        {(widthContext.widthSize<=2)?
        <div className={styles.bars} onClick={handleBurgerClick}><img src={widthContext.sideBar?timesSvg:barSvg} alt="bars"/></div>:<>
        {(context.loggedIn)?
        <LogoutComp/>
        :undefined}
        {(!context.loggedIn)?
        <LoginComp/>
        :undefined
        }
        </>
        }


        {/* {(context.loggedIn)?
        <LogoutComp/>
        :undefined}
        {(!context.loggedIn)?
        <LoginComp/>
        :undefined
        } */}



        </div>
        <nav className={styles.nav}>
            <ul>
                <li><NavLink exact activeClassName="activeClass" onClick={handleNavClick} to="/">Home</NavLink></li>
                <li><NavLink exact activeClassName="activeClass" onClick={handleNavClick} to="/category/general">General</NavLink></li>
                <li><NavLink exact activeClassName="activeClass" onClick={handleNavClick} to="/category/technology">Technology</NavLink></li>
                <li><NavLink exact activeClassName="activeClass" onClick={handleNavClick} to="/category/sports">Sports</NavLink></li>
                <li><NavLink exact activeClassName="activeClass" onClick={handleNavClick} to="/category/health">Health</NavLink></li>
                <li><NavLink exact activeClassName="activeClass" onClick={handleNavClick} to="/category/movies">Movies</NavLink></li>
                <li><NavLink exact activeClassName="activeClass" onClick={handleNavClick} to="/category/bio">Bio</NavLink></li>
            </ul>
        </nav>
        </>
    );
}

export default Navbar;